import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CookieIcon } from 'lucide-react';
const STORAGE_KEY = 'goldencare-cookies-accepted';
export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) {
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);
  const decide = (accepted: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, accepted ? 'true' : 'false');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };
  return <AnimatePresence data-id="element-86">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} role="dialog" aria-live="polite" aria-label="Obavijest o kolačićima" className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-3xl" data-id="element-87">
          <div className="glass flex flex-col items-start gap-4 rounded-2xl p-5 shadow-luxury ring-1 ring-gold/15 sm:flex-row sm:items-center sm:p-6" data-id="element-88">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold-gradient text-white shadow-gold" data-id="element-89">
              <CookieIcon className="h-5 w-5" data-id="element-90" />
            </span>
            <p className="flex-1 text-sm leading-relaxed text-ink" data-id="element-91">
              Koristimo neophodne kolačiće kako bi stranica radila sigurno i
              ispravno. Nastavkom korištenja prihvatate njihovu upotrebu.
            </p>
            <div className="flex w-full gap-3 sm:w-auto" data-id="element-92">
              <button type="button" onClick={() => decide(false)} className="flex-1 rounded-full border border-gold/30 px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-cream sm:flex-none" data-id="element-93">
                Odbij
              </button>
              <button type="button" onClick={() => decide(true)} className="flex-1 rounded-full bg-ink px-6 py-2.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03] active:scale-95 sm:flex-none" data-id="element-94">
                Prihvatam
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}